<template>
  <section>
    <div class="form-group">
                  <div class="row">
                    <div class="col-xs-12 col-sm-6">
                      <label class="inbox-label required">
                        {{ t("application.rental") }}
                      </label>
                      <MoneyInput
                        :fieldTitle="t('application.rental',{},'zh')"
                        fieldname="rental"
                        name="rental"
                        required
                        value=""
                      />
                    </div>
                    <div class="col-xs-12 col-sm-6">
                      <label class="inbox-label required">{{ t('application.no_of_employees') }}</label>
                      <IntegerInput
                        :fieldTitle="t('application.no_of_employees',{},'zh')"
                        fieldname="noOfEmployees"
                        name="employees"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-xs-12 col-sm-6">
                      <label class="inbox-label">{{ t('lead.feature_receivable_amount') }}</label>
                      <MoneyInput
                        :fieldTitle="t('lead.feature_receivable_amount',{},'zh')"
                        fieldname="receivableAmount"
                        name="receivableAmount"
                        value=""
                      />
                    </div>
                    <div class="col-xs-12 col-sm-6">
                      <label class="inbox-label">{{ t('lead.monthly_salary') }}</label>
                      <MoneyInput
                        :fieldTitle="t('lead.monthly_salary',{},'zh')"
                        fieldname="salary"
                        name="salary"
                        value=""
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-xs-12 col-sm-6">
                      <label class="inbox-label">{{ t('lead.question_outstanding_amount') }}</label>
                      <MoneyInput
                        :fieldTitle="t('lead.question_outstanding_amount',{},'zh')"
                        fieldname="outstandingAmount"
                        name="outstandingAmount"
                        value=""
                      />
                    </div>
                    <div class="col-xs-12 col-sm-6">
                      <label class="inbox-label">{{ t('lead.question_monthly_repayment') }}</label>
                      <MoneyInput
                        :fieldTitle="t('lead.question_monthly_repayment',{},'zh')"
                        fieldname="repayment"
                        name="repayment"
                        value=""
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-xs-12 col-sm-6">
                      <label class="inbox-label">{{ t('lead.monthly_income') }}</label>
                      <MoneyInput
                        :fieldTitle="t('lead.monthly_income',{},'zh')"
                        fieldname="digitalIncome"
                        name="digitalIncome"
                        value=""
                      />
                    </div>
                    <div class="col-sm-6 col-xs-12">
                      <label class="inbox-label">{{
                        t("lead.pos_system")
                      }}</label>
                      <v-select
                        :options="boolOptions"
                        v-model="hasPos"
                        :reduce="(option) => option.code"
                        :searchable="false"
                        :fieldTitle="t('lead.pos_system',{},'zh')"
                        :fieldValue="hasPos"
                        fieldname="pos"
                      />
                    </div>
                  </div>
                </div>
  </section>
</template>
<script>
import MoneyInput from "~/components/form/MoneyInput.vue";
import IntegerInput from "~/components/form/IntegerInput.vue";
export default {
  name: "Step2",
  components: {
    MoneyInput,
    IntegerInput,
  },
  data: function () {
    return {
      boolOptions: [],
      hasPos: ''
    };
  },
  mounted() {
    this.boolOptions = [
      { label: this.t('common.has'), code: this.t('common.has', null, 'zh') },
      { label: this.t('common.has_no'), code: this.t('common.has_no', null, 'zh') },
    ]
  },
  methods: {
  },
};
</script>
